// Copyright (c) 2016 Deere & Company

import MachineStatusUpdate from '../../product/machine-status-update/state-connector';

export default {
    component: MachineStatusUpdate,
    name: 'MACHINE_STATUS_UPDATE',
    path: 'machine-status-update'
};




// WEBPACK FOOTER //
// ./src/routes/products/machine-status-route.js